module.exports = __webpack_public_path__ + "static/media/img30.d9bb350b.JPG";